import { render, staticRenderFns } from "./TheEmployees.vue?vue&type=template&id=4b4d2910&"
import script from "./TheEmployees.vue?vue&type=script&lang=js&"
export * from "./TheEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports